<app-inner-box>
  <app-subpage-header [title]="title"></app-subpage-header>
  <app-list #listComponent [closedOrders]="true" (stats)="statsLoaded($event)"></app-list>
</app-inner-box>
